import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Grid,
} from '@material-ui/core';
import NewIdentityCard from '../../../../assets/cardIdentity/newIdentityCard.png';
import OldIdentityCard from '../../../../assets/cardIdentity/oldIdentityCard.png';
import { INFO_SERIE_IDENTITY_CARD } from '../../../../constants/texts';
import { usePreFormValidDniStyles } from '../styles';

const DialogInfoDni = ({ ...props }) => {
  const { mobile, open, handleClose } = props;
  const classes = usePreFormValidDniStyles({ mobile });

  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.paperDialog }}
      >
        <DialogTitle disableTypography className={classes.titleDialog}>
          {INFO_SERIE_IDENTITY_CARD}
        </DialogTitle>
        <DialogContent className={classes.contentDialog} dividers>
          <Grid className={classes.grid} item md={12} xs={12}>
            <DialogContentText className={classes.textDialog}>
              Nueva cédula de identidad:
            </DialogContentText>
            <img
              data-cy="newIdentityCardImage"
              className={classes.image}
              src={NewIdentityCard}
              alt="Carnet nuevo"
            />
          </Grid>

          <Grid className={classes.grid} item md={6} xs={12}>
            <DialogContentText className={classes.textDialog}>
              Cédula de identidad:
            </DialogContentText>
            <img
              data-cy="oldIdentityCardImage"
              className={classes.image}
              src={OldIdentityCard}
              alt="Carnet antiguo"
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            data-cy="closeButtonDialog"
            color="primary"
            variant="contained"
            onClick={handleClose}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

DialogInfoDni.propTypes = {
  mobile: PropTypes.bool,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default DialogInfoDni;
